<template lang="pug">
    .lairdnd-app
        component(:is="layout" :class="layoutClass")
            router-view
</template>

<script>
import { mapGetters } from 'vuex'

const DEFAULT_LAYOUT = 'main'

export default {
    name: 'lairdnd-app',

    metaInfo: {
        titleTemplate: (titleChunk) => titleChunk ? `${titleChunk} - Lair DND` : 'Lair DND',
        meta: [
            { name: 'og:locale', content: 'en_US' },
            { name: 'og:type', content: 'website' },
            { name: 'og:title', content: 'Lair DND' },
            { name: 'og:url', content: window.location.href },
            { name: 'og:site_name', content: 'Lair DND' },
            { name: 'og:image', content: window.location.href + '/images/home-bg.jpg' },
        ],
    },

    computed: {
        ...mapGetters(['authUser', 'authCheck']),

        layout() {
            return `${this.$route.meta.layout || DEFAULT_LAYOUT}-layout`
        },
        layoutClass() {
            return this.$route.meta?.class
        },
    },

    watch: {
        authCheck(current, prev) {
            if (prev && !current) {
                this.$route.matched[0].beforeEnter(this.$route, null, to => {
                    if (to) {
                        this.$router.push(to)
                    }
                })
            }
        },
    },

    async created() {
        if (typeof InstallTrigger !== 'undefined') {
            document.body.classList.add('firefox')
        }

        if (this.$store.getters.authCheck) {
            try {
                await this.$store.dispatch('fetchUser')
            } finally {
                if (!this.$store.getters.authCheck) {
                     this.$route.matched[0].beforeEnter(this.$route, null, to => {
                        if (to) {
                            this.$router.push(to)
                        }
                    })
                }
            }
        }
    },

    mounted() {
        const resize = function() {
            let zoom = 1
            if (window.innerWidth >= 992) {
                zoom = 0.8
            }

            const vh = (window.innerHeight / zoom) * 0.01;

            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }

        window.addEventListener('resize', () => {
            resize();
        });

        resize();
    }
}
</script>
